var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"navigation-footer"},[_c('p',{staticClass:"navigation-footer__copyright"},[_vm._v(_vm._s(_vm.currentYear)+" © Ophelia Fournier-Laflamme")])])}
var staticRenderFns = []

export { render, staticRenderFns }